module.exports = __webpack_public_path__ + "static/media/page_qyj_btn.a3530bf0.png";